<template>
  <div class="bwauth-social">
    <div class="bwauth-social-divider">
      <span>{{ $t('or') }}</span>
    </div>

    <button type="button" class="bwauth-social-button" @click="authProvider('google')">
      <img :src="googleIconSrc" alt="Google">
      <span>{{ googleText }}</span>
    </button>

    <button
      v-if="showAppleLogin"
      type="button"
      class="bwauth-social-button bwauth-social-button-apple"
      @click="authProvider('apple')"
    >
      <img :src="appleIconSrc" alt="Apple">
      <span>{{ appleText }}</span>
    </button>
  </div>
</template>

<script>
import AuthApi from './AuthApi';
import googleIcon from './icons/google.svg';
import appleIcon from './icons/apple.svg';

export default {
  props: {
    mode: {
      type: String,
      default: 'login',
    },
    redirectUrl: {
      type: String,
      default: null,
    },
  },
  computed: {
    googleIconSrc() {
      return googleIcon.default || googleIcon;
    },
    appleIconSrc() {
      return appleIcon.default || appleIcon;
    },
    isRegisterMode() {
      return this.mode === 'register';
    },
    googleText() {
      return this.isRegisterMode
        ? this.$t('Register with Google')
        : this.$t('Login with Google');
    },
    appleText() {
      return this.isRegisterMode
        ? this.$t('Register with Apple')
        : this.$t('Login with Apple');
    },
    showAppleLogin() {
      return window.navigator
        && window.navigator.userAgent
        && window.navigator.userAgent.includes('cordova-app-ios');
    },
  },
  methods: {
    authProvider(provider) {
      const isCordova = window.navigator
        && window.navigator.userAgent
        && window.navigator.userAgent.includes('cordova-app');
      // const isCordova = true;

      if (isCordova) {
        window.location = `${process.env.VUE_APP_APP_URL || process.env.MIX_APP_URL}/api/social/redirect/${provider}?redirect_url=${encodeURIComponent(window.location.href)}`;
        return;
      }

      this.$auth.authenticate(provider)
        .then((response) => this.socialLogin(provider, response));
    },
    socialLogin(provider, response) {
      const urlParams = new URLSearchParams(window.location.search);
      const redirectUrl = this.redirectUrl || urlParams.get('redirect_url') || null;

      AuthApi.csrf()
        .then(() => AuthApi.postSocialLogin(provider, response))
        .then(({ data }) => {
          this.$emit('success', data.user || data);
        })
        .catch((error) => {
          this.$emit('error', error);
        });
    },
  },
};
</script>
